import { setShowSuccess } from 'actions/ui';
import Sorter from 'components/admin/forms/sorter';
import { Forms, Modal, SaveButton, SystemText, TitleBar } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGet, apiPatch } from 'services';

export const SortMetrics = ({ show, onClose }) => {
    const dispatch = useDispatch();

    const [saving, setSaving] = React.useState(false);
    const [crmJobs, setCrmJobs] = React.useState();
    const [crmJobsList, setCrmJobsList] = React.useState([]);
    const [integrationFields, setIntegrationFields] = React.useState();
    const [integrationFieldsList, setIntegrationFieldsList] = React.useState([]);
    const [selectedMetricType, setSelectedMetricType] = React.useState('CRM');

    const user = useSelector(state => state.user.user);

    const api = {
        save: callback => {
            const item = {
                crmJobs,
                integrationFields,
            };

            apiPatch('metric-sort', item, user.guid, () => {
                dispatch(setShowSuccess(SystemText('Admin/Metrics/Sort/Success')));
                callback?.();
                onClose?.();
            });
        },
        loadIntegrationFields: () => apiGet(`integration-fields`, user.guid, response => setIntegrationFieldsList(response)),
        loadCRMJobs: () => apiGet(`crm-job`, user.guid, response => setCrmJobsList(response)),
    };

    React.useEffect(() => {
        api.loadIntegrationFields();
        api.loadCRMJobs();
    }, []);

    const setIntegrationFieldsUnique = fields => {
        const fieldsWithoutCurrentSelection = (integrationFields || integrationFieldsList).filter(
            f => f.ref !== selectedMetricType
        );
        const newFields = fieldsWithoutCurrentSelection.concat(fields);
        setIntegrationFields(newFields);
    };

    const mappedFields = integrationFieldsList.reduce((all, c) => {
        return all.some(a => a.id === c.ref) ? all : all.concat([{ id: c.ref, name: c.integration }]);
    }, []);

    const availableMetrics = [{ id: 'CRM', name: 'CRM' }, ...mappedFields];

    const footer = (
        <div className="pull-right">
            <SaveButton saving={saving} setSaving={setSaving} className="btn btn-success" onClick={() => api.save()}>
                {SystemText('Admin/Metrics/Sort/Buttons/Save')}
            </SaveButton>
            <button className="btn" onClick={() => onClose()}>
                {SystemText('Admin/Metrics/Sort/Buttons/Close')}
            </button>
        </div>
    );

    return (
        <Modal show={show} title={SystemText('Admin/Metrics/Sort/Title')} close={onClose} footer={footer}>
            <div className="row">
                <div className="col-md-12">
                    <Forms.Select
                        label={SystemText('Admin/Metrics/Sort/Filter')}
                        onChange={value => setSelectedMetricType(value)}
                        value={selectedMetricType}
                        mandatory
                        data={availableMetrics}
                        data-testid="select-metric"
                    />
                </div>
            </div>
            <div className="row">
                <div
                    data-testid="sorter-crm"
                    className="col-md-12"
                    style={{ display: selectedMetricType === 'CRM' ? 'block' : 'none' }}
                >
                    <Sorter
                        label={SystemText('Admin/Metrics/Sort/Label', 'CRM')}
                        help={SystemText('Admin/Metrics/Sort/Help', 'CRM')}
                        options={crmJobs || crmJobsList}
                        narrow
                        onChange={options => setCrmJobs(options)}
                    />
                </div>
                {mappedFields.map(f => {
                    return (
                        <div
                            key={`integration-${f.id}`}
                            data-testid="sorter-integration"
                            className="col-md-12"
                            style={{ display: selectedMetricType === f.id ? 'block' : 'none' }}
                        >
                            <Sorter
                                label={SystemText('Admin/Metrics/Sort/Label', f.name)}
                                help={SystemText('Admin/Metrics/Sort/Help', f.name)}
                                options={(integrationFields || integrationFieldsList).filter(i => i.ref === f.id)}
                                narrow
                                onChange={integrationFields => setIntegrationFieldsUnique(integrationFields)}
                            />
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
};

export default SortMetrics;
